import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFieldMobileVp = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={375}
        height={624}
        fill="none"
        viewBox="0 0 375 624"
        {...props}
    >
        <path fill="#2B632D" d="M2 2h370.032v62H2z" />
        <path fill="#367C38" d="M2 64h370.032v62H2z" />
        <path fill="#2B632D" d="M2 126h370.032v62H2z" />
        <path fill="#367C38" d="M2 188h370.032v62H2z" />
        <path fill="#2B632D" d="M2 250h370.032v62H2z" />
        <path fill="#367C38" d="M2 312h370.032v62H2z" />
        <path fill="#2B632D" d="M2 374h370.032v62H2z" />
        <path fill="#367C38" d="M2 436h370.032v62H2z" />
        <path fill="#2B632D" d="M2 498h370.032v62H2z" />
        <path fill="#367C38" d="M2 560h370.032v62H2z" />
        <path
            stroke="#fff"
            strokeOpacity={0.2}
            strokeWidth={4}
            d="M150.991 534H80v88h214.336v-88h-70.988m-72.357 0c7.475-12 20.883-20 36.179-20s28.703 8 36.178 20m-72.357 0h72.357M151.156 90H80.164V2H294.5v88h-70.988m-72.356 0c7.475 12 20.882 20 36.178 20s28.703-8 36.178-20m-72.356 0h72.356M2 14.692c.8.201 1.637.308 2.5.308 5.584 0 10.11-4.477 10.11-10a9.9 9.9 0 0 0-.463-3M2 14.692V622h370.032V2H14.147M2 14.692V2h12.147M372 14.692a10.2 10.2 0 0 1-2.5.308c-5.584 0-10.11-4.477-10.11-10 0-1.045.162-2.053.463-3m12.179 607.5a10.2 10.2 0 0 0-2.5-.308c-5.584 0-10.11 4.477-10.11 10 0 1.045.162 2.053.463 3M1.853 609.308c.8-.201 1.637-.308 2.5-.308 5.583 0 10.11 4.477 10.11 10a9.9 9.9 0 0 1-.463 3M2 312h370.032m-234.09 278H235v32h-97.058zm.165-556h97.057V2h-97.057zm93.862 278c0 24.301-19.916 44-44.484 44S143 336.301 143 312s19.916-44 44.485-44 44.484 19.699 44.484 44Z"
        />
        <path fill="#5E9660" d="M186.908 318c3.35 0 6.066-2.686 6.066-6h-12.132c0 3.314 2.716 6 6.066 6" />
        <path fill="#558257" d="M187.066 306c3.35 0 6.066 2.686 6.066 6H181c0-3.314 2.716-6 6.066-6" />
    </svg>
);
export default SvgFieldMobileVp;
